export DsfSubTable from "./subTable.vue";
// export DsfSubTableColumn from "./subTableColumn.vue";
// export DsfSubTableCellContent from "./subTableCellContent.vue";

export const DsfSubTableColumn =dsf.defineLazyComponent('DsfSubTableColumn',()=>require("./subTableColumn.vue"));
export const DsfSubTableCellContent =dsf.defineLazyComponent('DsfSubTableCellContent',()=>require("./subTableCellContent.vue"));

